// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"7e54035b","239":"36a8e7c6","284":"226e62e2","305":"31ea26f8","537":"cd8d9163","561":"78ebd1ef","730":"1362d1e8","952":"061fa008","995":"fa709a8e"}[chunkId] + ".chunk.css";
};